// extracted by mini-css-extract-plugin
module.exports = {"rightCol":"Header_rightCol__2Nab1","leftCol":"Header_leftCol__So9xW","root":"Header_root__15U4d","titleWrapper":"Header_titleWrapper__3k64E","title":"Header_title__3JDVq"};